var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVr = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 234,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  stroke: "#fff",
  strokeWidth: 0.765,
  d: "m15 112-7 7-7-7 7-7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  stroke: "#fff",
  strokeWidth: 0.765,
  d: "M12.06 112 8 116.06 3.94 112 8 107.94z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M8.5 129v105M8.5 0v94"
})));
export { SvgVr as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjM0IiB2aWV3Qm94PSIwIDAgMTYgMjM0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjE1IiB5PSIxMTIiIHdpZHRoPSI5Ljg5OTU0IiBoZWlnaHQ9IjkuODk5NTQiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxNSAxMTIpIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuNzY0NjY5Ii8+CjxyZWN0IG9wYWNpdHk9IjAuNSIgeD0iMTIuMDU5NiIgeT0iMTEyIiB3aWR0aD0iNS43NDA4OCIgaGVpZ2h0PSI1Ljc0MDg4IiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgMTIuMDU5NiAxMTIpIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuNzY0NjY5Ii8+CjxsaW5lIHgxPSI4LjUiIHkxPSIxMjkiIHgyPSI4LjUiIHkyPSIyMzQiIHN0cm9rZT0id2hpdGUiLz4KPGxpbmUgeDE9IjguNSIgeTE9Ii0yLjE4NTU3ZS0wOCIgeDI9IjguNSIgeTI9Ijk0IiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo=";